import { useContext } from "react";
import { AppContext } from "./Context";

export default function useAppStore() {
  return useContext(AppContext);
}
